import React from "react";

class ShowPerformers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            performers: [],
        };
        this.handleClickChange = this.handleClickChange.bind(this);
    }

    handleClickChange(event) {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value,
        });
    }

    handleEvent() {
        this.state = {
            performers:
                this.props.performers.length > 0 ? this.props.performers : [],

        };

    }

    render() {
        this.handleEvent();
        return (
            <div
                className="modal fade"
                tabIndex={-1}
                role="dialog"
                id="show-performers-list-modal"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Uitvoeders</h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            {this.state.performers && this.state.performers.map((user) => (
                                <div className="performer-list">
                                    <div className="performer-content">
                                        <span className="performer-ico"></span>
                                        <div className="performer-name">
                                            {user.relationships['related_instance'].name}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="modal-footer"></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ShowPerformers;
